import { render, staticRenderFns } from "./GuidelineComponent.vue?vue&type=template&id=1cafad92&scoped=true&"
import script from "./GuidelineComponent.vue?vue&type=script&lang=js&"
export * from "./GuidelineComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cafad92",
  null
  
)

export default component.exports